import { createContext, useContext } from 'react'

interface IIteratorProviderProps {
    children: React.ReactNode
    id: string
}
interface IIteratorContext {
    id: string
}
const IteratorProviderContext = createContext<IIteratorContext>({
    id: '',
})
export const IteratorProvider = ({ children, id }: IIteratorProviderProps) => {
    return (
        <IteratorProviderContext.Provider value={{ id: id }}>
            {children}
        </IteratorProviderContext.Provider>
    )
}

export const useIteratorProvider = () => {
    return useContext(IteratorProviderContext)
}
